import axios from 'axios';

const API = axios.create({
	baseURL: process.env.REACT_APP_DOCUSIGN_API_URL || 'http://localhost:8080',
});

export const sendContract = (data) => API.post('/send-contract', data);
export const getEnvelopeStatus = (envelopeId) =>
	API.get(`/status/${envelopeId}`);
